import styled from '@emotion/styled'
import React from 'react'
import Image from 'next/image'

type Props = {
  values: ReadonlyArray<{ imagePath: string; value: string }>
  onChange: (selectedColor: string) => void
  value: string
}

export const ImageSelector: React.FC<Props> = ({ onChange, value, values }) => {
  const items = values.map((c, index) => {
    return (
      <Item
        key={index}
        onClick={() => {
          onChange(c.value)
        }}
        selected={value === c.value}
      >
        <Image
          width={40}
          height={40}
          priority={true}
          unoptimized={true}
          src={c.imagePath}
          alt={c.value}
        />
      </Item>
    )
  })
  return <Container>{items}</Container>
}

const Container = styled.div`
  width: 100%;
  border: 3px solid #b7d7ea;
  background-color: #fff;
  border-radius: 4px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
`

const Item = styled.div<{ selected: boolean }>`
  line-height: 0;
  border: 4px solid ${({ selected }) => (selected ? '#b7d7ea' : 'transparent')};
  border-radius: 4px;
  width: 40px;
  height: 40px;
`
